import { Tab, TabsComponent } from "../../../components/Tabs";
import { Invite } from "./Invite";
import { ManageParticipants } from "./ManageParticipants";

export function Participants() {
  return (
    <div className="mx-auto">
      <TabsComponent>
        <Tab id="Manage" label="Manage" icon="fa-user-minus">
          <ManageParticipants />
        </Tab>
        <Tab id="Invite" label="Invite" icon="fa-user-plus">
          <Invite/>
        </Tab>
      </TabsComponent>
    </div>
  );
}